import cn from 'classnames';
import { Button } from 'antd';
import { I18nt } from 'utils';
import { LangText } from 'utils/interfaces';
import Container from 'components/Container';
import styles from './DownloadPage.module.less';
import BannerWithImage from 'components/BannerWithImage';
import { ArrowLeftOutlined, DownloadOutlined } from '@ant-design/icons';

interface Props {
	title: string;
	href?: string;
	text: LangText;
	download?: LangText;
	subTitle?: LangText;
	subTitle2?: LangText;
	goBackText: LangText;
	downloadBtn: LangText;
	btnAction: () => void;
	goBackAction: () => void;
}

export default function DownloadPage({
	text,
	href,
	title,
	download,
	subTitle,
	btnAction,
	subTitle2,
	goBackText,
	downloadBtn,
	goBackAction,
}: Props) {
	const button = () => {
		if (href && download) {
			return (
				<a
					href={href}
					download={I18nt(download)}
					onClick={btnAction}
					className={styles.download}
				>
					<DownloadOutlined />
					{I18nt(downloadBtn)}
				</a>
			);
		}
		return (
			<button
				onClick={btnAction}
				className={cn(styles.button, styles.download)}
			>
				<DownloadOutlined />
				{I18nt(downloadBtn)}
			</button>
		);
	};

	return (
		<BannerWithImage className={styles.downloadPage}>
			<Container className={styles.container}>
				<div className={styles.buttonWrapper}>
					<Button
						className={styles.goBackBtn}
						onClick={goBackAction}
						type='link'
					>
						<ArrowLeftOutlined />
						{I18nt(goBackText)}
					</Button>
				</div>
				<div>
					<h4>{title}</h4>
					{subTitle && <p>{I18nt(subTitle)}</p>}
				</div>
				<p>{I18nt(text)}</p>
				{button()}
				<div className={styles.subTitle2}>
					{subTitle2 && <p>{I18nt(subTitle2)}</p>}
				</div>
			</Container>
		</BannerWithImage>
	);
}
